import { API_PREFIX_BANNER_PATH } from "@/constants/prefix-path-api"
import httpClient from "@/lib/http-client"
import { BannerData } from "@/types/types"

// Cache to dedupe banner requests across client navigations/remounts.
// Key is based on the API filter fields (page + position).
const bannerRequestCache = new Map<string, Promise<BannerData | null>>()

export const fetchCategoryBannerData = async (
  page: string = "CATEGORY",
  position: string = "TOP_CONTENT",
): Promise<BannerData | null> => {
  const normalizedPage = page.toUpperCase()
  const normalizedPosition = position.toUpperCase().trim()
  const cacheKey = `${normalizedPage}__${normalizedPosition}`

  const cached = bannerRequestCache.get(cacheKey)
  if (cached) return cached

  const requestPromise = (async () => {
    try {
      const params = {
        populate: "*",
        sort: "createdAt:desc",
        publicationState: "live",
        filters: {
          page: { $eq: normalizedPage },
        },
        pagination: {
          pageSize: "10",
        },
        locale: "all",
      }

      // `httpClient` already prepends `/api/`, so we pass `banners` instead of `/api/banners`.
      const response = await httpClient.get<any>(API_PREFIX_BANNER_PATH, params, {
        next: { revalidate: 3600, tags: [`category_banner_${normalizedPage}_${normalizedPosition}`] },
      })

      if (!response?.data) {
        return null
      }

      const banners = Array.isArray(response.data) ? response.data : response.data.data || []

      if (banners.length > 0) {
        const filteredBanner = banners.find((b: BannerData) => {
          const bannerPage = (b.attributes?.page || "").toUpperCase()
          const bannerPosition = (b.attributes?.position || "").toUpperCase().trim()
          return bannerPage === normalizedPage && bannerPosition === normalizedPosition
        })

        return filteredBanner || null
      }

      return null
    } catch (error) {
      console.error("Lỗi khi lấy banner bằng category:", error)
      return null
    }
  })()

  bannerRequestCache.set(cacheKey, requestPromise)
  return requestPromise
}
